<!-- 由 suu 创建于 2019-09-06 Friday -->
<template>
  <div class="Calendar" :class="{ 'Calendar-img': getImg }">
    <div class="title title-img" v-if="getImg">
      <div class="cur-month">{{ curYear }}年{{ curMonth }}月</div>
    </div>
    <div class="title" v-else>
      <van-icon name="arrow-left" @click="onLastMonth" />
      <div class="cur-month">
        {{ curYear }}.{{ curMonth }}.{{ clickDay - curMonthFirstWeek }}
        {{ curWeek }}
      </div>
      <van-icon name="arrow" @click="onNextMonth" />
    </div>
    <div class="content">
      <div class="week-text">
        <span
          :style="{ width: 100 / 7 + '%' }"
          v-for="(item, index) in weekText"
          :key="index"
          >周{{ item }}</span
        >
      </div>
      <div class="days">
        <div
          class="day"
          :class="{
            'train-day': isCourseDay(index),
            'ac88-day': isAc88(index),
            'stage-day': stageEnd(index)
          }"
          :style="{ width: 100 / 7 + '%' }"
          v-for="(item, index) in allDays"
          :key="index"
        >
          <template v-if="getImg">
            <div :class="{ 'click-day-img': clickDay == index + 1 && !getImg }">
              {{
                index - curMonthFirstWeek >= 0
                  ? index - curMonthFirstWeek + 1
                  : ' '
              }}
            </div>
            <div
              class="ac88-out"
              v-if="isAc88(index) && isAc88Outside(index) && curType == 0"
            >
              场外
            </div>
            <img
              class="day-q-img"
              src="@/assets/calendar/gym-cal-qh.png"
              v-if="isCourseDay(index) && curType == 0"
              alt
            />
            <img
              class="day-q-img"
              src="@/assets/calendar/gym-cal-ql.png"
              v-else-if="
                curType == 1 &&
                training &&
                training[
                  `${curYear}-${_formateTime(curMonth)}-${_formateTime(
                    index - curMonthFirstWeek + 1
                  )}`
                ]
              "
              alt
            />
            <img
              class="day-q-img"
              src="@/assets/calendar/gym-cal-qy.png"
              v-else-if="
                food &&
                food[
                  `${curYear}-${_formateTime(curMonth)}-${_formateTime(
                    index - curMonthFirstWeek + 1
                  )}`
                ]
              "
              alt
            />
          </template>
          <template v-else>
            <div
              :class="{ 'click-day': clickDay == index + 1 }"
              @click="onClickDay(index)"
            >
              {{
                index - curMonthFirstWeek >= 0
                  ? index - curMonthFirstWeek + 1
                  : ' '
              }}
            </div>
            <!-- 上课 -->
            <div
              class="ac88-out"
              v-if="isAc88(index) && isAc88Outside(index) && curType == 0"
            >
              场外
            </div>
            <div
              class="cur-day"
              v-if="isCourseDay(index) && curType == 0"
            ></div>
            <!-- 训练记录 -->
            <div
              class="cur-day outside-no"
              v-else-if="
                curType == 1 &&
                training &&
                training[
                  `${curYear}-${_formateTime(curMonth)}-${_formateTime(
                    index - curMonthFirstWeek + 1
                  )}`
                ]
              "
            ></div>
            <!-- 饮食打卡 -->
            <div
              class="cur-day outside"
              v-else-if="
                food &&
                food[
                  `${curYear}-${_formateTime(curMonth)}-${_formateTime(
                    index - curMonthFirstWeek + 1
                  )}`
                ]
              "
            ></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calendar',

  components: {},

  props: {
    getImg: {
      type: Boolean,
      default: false
    },
    curType: {
      type: [String, Number],
      default: 0
    },
    course: {
      type: [Object, Array],
      require: true
    },
    food: {
      type: [Object, Array]
    },
    training: {
      type: [Object, Array]
    }
  },

  data() {
    return {
      uid: this.$route.query.uid,
      recordDays: [],
      weekText: ['日', '一', '二', '三', '四', '五', '六'],
      weekText2: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ],
      curMonthDays: 30, // 当前月份天数
      curYear: new Date().getFullYear(),
      curMonth: new Date().getMonth() + 1,
      curDay: new Date().getDate(),
      curMonthFirstWeek: 0, // 当前月第一天星期几
      allDays: [], // 当月天数加第一天星期几总数组
      clickDay: new Date().getDate()
    }
  },

  computed: {
    curWeek() {
      // eslint-disable-next-line
      return this.weekText2[
        new Date(
          `${this.curYear}/${this.curMonth}/${
            this.clickDay - this.curMonthFirstWeek
          }`
        ).getDay()
      ]
    },
    curDayText() {
      return `${this.curYear}-${this._formateTime(
        this.curMonth
      )}-${this._formateTime(this.clickDay - this.curMonthFirstWeek)}`
    },
    // 88活动或运动不停歇活动信息  优化运动不停歇
    activityInfo() {
      return (
        this['$store'].state.activitySports ||
        this['$store'].state.activity88 ||
        null
      )
    }
  },

  watch: {
    curType(newV, oldV) {
      this.getCurDayInfo()
    }
  },

  created() {
    // 获取传入的默认年月
    this.curMonth = this.$route.query.month || new Date().getMonth() + 1
    this.curYear = this.$route.query.year || new Date().getFullYear()
    this.getInfo(1)
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 判断是否在88活动某一阶段的结尾
     * 或运动不停歇活动
     */
    stageEnd(index) {
      if (!this.activityInfo || !this.activityInfo.step_one_s) {
        return false
      } else {
        let curDay = `${this.curYear}-${this._formateTime(
          this.curMonth
        )}-${this._formateTime(index - this.curMonthFirstWeek + 1)}`
        if (
          curDay === this.activityInfo.step_one_e ||
          curDay === this.activityInfo.step_two_e
        ) {
          return true
        }
      }
      return false
    },
    /**
     * 判断是否在88活动期间的场外打卡
     * 或者运动不停歇活动
     */
    isAc88Outside(index) {
      if (!this.activityInfo || !this.activityInfo.step_one_s) {
        return false
      } else {
        let curDay = `${this.curYear}-${this._formateTime(
          this.curMonth
        )}-${this._formateTime(index - this.curMonthFirstWeek + 1)}`
        for (
          let index = 0;
          index < this.activityInfo.out_list.length;
          index++
        ) {
          const v = this.activityInfo.out_list[index]
          if (v.act_day === curDay) {
            return true
          }
        }
      }
      return false
    },
    /**
     * 判断是否在88活动期间
     * 或运动不停歇活动
     */
    isAc88(index) {
      if (!this.activityInfo || !this.activityInfo.step_one_s) {
        return false
      } else {
        let curDay = `${this.curYear}/${this._formateTime(
          this.curMonth
        )}/${this._formateTime(index - this.curMonthFirstWeek + 1)}`
        let sDay = new Date(
          this.activityInfo.step_one_s.replace(/-/g, '/')
        ).getTime()
        let eDay = new Date(
          this.activityInfo.step_three_e.replace(/-/g, '/')
        ).getTime()
        if (
          new Date(curDay).getTime() <= eDay &&
          new Date(curDay).getTime() >= sDay
        ) {
          return true
        }
      }
      return false
    },
    /**
     * 判断是否上课
     */
    isCourseDay(index) {
      // console.log('this.course', this.course, this.curType)
      if (!this.course) {
        return false
      }
      let curDay = `${this.curYear}-${this._formateTime(
        this.curMonth
      )}-${this._formateTime(index - this.curMonthFirstWeek + 1)}`
      if (this.course[curDay]) {
        return true
      }
      return false
    },
    /**
     * 得到当前日训练信息
     */
    getCurDayInfo() {
      let obj = null
      if (this.course && Number(this.curType) === 0) {
        obj = this.course[this.curDayText]
      }
      obj = Object.assign({}, obj, {
        curDayText: this.curDayText,
        curDayMore: `${this.curYear}.${this.curMonth}.${
          this.clickDay - this.curMonthFirstWeek
        } ${this.curWeek}`
      })
      this.$emit('OnClickDay', obj)
    },
    /**
     * 点击日期
     */
    onClickDay(day) {
      this.clickDay = day + 1
      this.getCurDayInfo()
    },
    /**
     * 获取基本信息
     */
    getInfo(first = 0) {
      let curYear = this.curYear
      let curMonth = this.curMonth
      //  curMonth = 2
      // 当前月第一天星期几
      let dCalDate = new Date(curYear, curMonth - 1, 1)
      let curMonthFirstWeek = dCalDate.getDay()
      // 获取本月天数(获取后一个月的0日即前一月的最后一日)
      var curMonthDays = new Date(
        dCalDate.getFullYear(),
        dCalDate.getMonth() + 1,
        0
      ).getDate()
      // console.log('本月共有 ' + curMonthDays + ' 天')
      let allDays = new Array(curMonthFirstWeek)
      allDays = allDays.concat(new Array(curMonthDays))
      let curDay = new Date().getDate() + curMonthFirstWeek
      // console.log(
      //   '本月第一天周 ' + curMonthFirstWeek + '当前天' + curDay,
      //   allDays
      // )
      this.setData({
        curMonthDays,
        curMonthFirstWeek,
        allDays,
        curMonth,
        curYear,
        curDay,
        clickDay: curDay
      })
      // 判断是否自动跳到上月
      if (
        !sessionStorage.getItem('autoLastMonth') &&
        this.$route.query.autoLast
      ) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.onLastMonth()
            sessionStorage.setItem('autoLastMonth', 1)
          })
        }, 200)
      } else {
        this.getCurDayInfo()
      }
    },
    /**
     * 上月
     */
    onLastMonth() {
      let curYear = this.curYear
      let curMonth = this.curMonth - 1
      if (curMonth <= 0) {
        curMonth = 12
        curYear -= 1
      } else if (curMonth > 12) {
        curMonth = 1
        curYear += 1
      }
      this.setData({
        curMonth,
        curYear
      })
      this.onMonthChange()
    },
    /**
     * 下月
     */
    onNextMonth() {
      let curYear = this.curYear
      let curMonth = this.curMonth + 1
      if (curMonth <= 0) {
        curMonth = 12
        curYear -= 1
      } else if (curMonth > 12) {
        curMonth = 1
        curYear += 1
      }
      this.setData({
        curMonth,
        curYear
      })
      this.onMonthChange()
    },
    onMonthChange(flag = 0) {
      if (!flag) this.$toast.loading('加载中···')
      this.$http
        .get(
          'member/Poster?a=getStatistics',
          {
            uid: this.uid,
            ym: `${this.curYear}-${this._formateTime(this.curMonth)}`
          },
          true
        )
        .then((res) => {
          this.$toast.clear()
          if (res.data.code === 200) {
            this.$emit('monthChange', res.data.data)
            setTimeout(() => {
              this.$nextTick(() => {
                this.getInfo()
              })
            }, 200)
          } else {
            this.$$dialog.alert({ message: res.data.msg })
          }
        })
        .catch((err) => {
          this.$toast.clear()
          this.$$dialog.alert({ message: '网络错误' })
        })
    },
    _formateTime(m) {
      return String(m)[1] ? m : '0' + m
    },
    setData(obj) {
      Object.keys(obj).map((v) => {
        this[v] = obj[v]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.Calendar {
  // width: 100%;
  padding: vw(28) vw(40);
  padding-bottom: 3.2vw;
  background-color: #fff;
  margin-top: 2.7vw;
  box-sizing: border-box;
}
.Calendar-img {
  padding: vw(28) vw(15);
}
.user-btn:active {
  transform: scale(0.8);
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: vw(56);
  // background-color: rgba($color: #f5f5f5, $alpha: 0.4);
  border-radius: vw(4);
  color: #000;
  padding: 0 vw(28);
  box-sizing: border-box;
  letter-spacing: vw(0.5);
  font-weight: 450;
}
.title > i {
  font-size: vw(32);
  color: #dc0050;
  margin: 0 7.7vw;
}

.cur-month {
  font-size: vw(30);
  color: #000;
}
.content {
  margin: 3vw 0;
  margin-bottom: 0;
  // padding: 0 vw(20);
}
.week-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-weight: 450;
}
.week-text text {
  text-align: center;
}

.days {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}
.day {
  height: vw(48);
  text-align: center;
  margin-top: vw(24);
  position: relative;
  font-size: 3.5vw;
  color: #000;
  font-weight: 450;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.train-day {
  background-color: rgba($color: #fff, $alpha: 0.14);
}
.click-day {
  // background-color: rgba($color: #fff, $alpha: 0.27);
  background-color: #dc0050;
  color: #fff;
  font-weight: 550;
  border-radius: 50%;
  width: vw(48);
  height: vw(48);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ac88-day {
  // background-color: #d8e8f7;
  background-color: rgba($color: #f45f5f, $alpha: 0.1);
}
.stage-day::after {
  content: '';
  width: 0.6vw;
  height: 90%;
  background-color: #fff;
  position: absolute;
  right: 0vw;
  top: 5%;
  z-index: 1;
}
.ac88-out {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: vw(-24);
  font-size: 2.4vw;
  color: #dc0050;
  font-weight: 600;
}
.cur-day {
  width: vw(12);
  height: vw(12);
  line-height: vw(12);
  background-color: #dc0050;
  color: #000;
  text-align: center;
  border-radius: 50%;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: vw(-14);
}
.outside {
  background-color: #f7b500;
}
.outside-no {
  background-color: #4e92df;
}
.record {
  width: vw(36);
  height: vw(27);
  position: absolute;
  bottom: -vw(25);
  left: 50%;
  transform: translateX(-50%);
}
.record-btn {
  /* float: right; */
  width: vw(160);
  height: vw(36);
  line-height: vw(36);
  background-color: #40b475;
  color: #000;
  font-size: vw(22);
  margin-right: vw(28);
  border-radius: 100px;
  text-align: center;
  position: absolute;
  right: 0;
}
// 生成图片时
.title-img {
  background-color: #eef0f3;
  border-radius: 1.3vw;
  width: 82.9vw;
  height: 6.4vw;
  font-size: 4.8vw;
  font-weight: 550;
  padding: 0;
  margin: 0 auto;
}
.click-day-img {
  color: #dc0050;
}
.day-q-img {
  width: 8.8vw;
  position: absolute;
}
</style>
